import React, { PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

interface PaperProps extends PropsWithChildren {
  bgColor?: "muted" | "light" | "dark";
  className?: string;
}

const getClassForTheme = (bgColor: PaperProps["bgColor"]) => {
  switch (bgColor) {
    case "muted":
      return "bg-muted";
    case "light":
      return "bg-white";
    case "dark":
      return "bg-[#1E2939]";
    default:
      return "bg-white";
  }
};
export function Paper({ children, bgColor = "light", className }: PaperProps) {
  return (
    <div
      className={cn(
        "p-6 md:p-10",
        getClassForTheme(bgColor),
        className
      )}
    >
      {children}
    </div>
  );
}
